import { Course } from '../types';

export const courses: Course[] = [
  {
    id: 'ia-para-potenciar-tu-productividad-profesional',
    title: 'IA para Potenciar tu Productividad Profesional',
    description: 'Aprende a redactar informes, responder correos, analizar datos y diseñar flujos semiautomatizados con IA. Usa IA generativa para hacer en minutos lo que antes te tomaba horas.',
    duration: '10 horas',
    level: 'especializado',
    image: '/images/04-capacitaciones/curso26agosto/ia_portada.webp',
    price: {
      costo: {
        uni: 200,
        gen: 250,
      },
      preventa: {
        uni: 200,
        gen: 250
      }
    },
    category: 'IA',
    modality: 'online',
    startDate: '2026-08-17',
    docente: [
      {
        name: 'Mirna Ampuero',
        proffession: 'Ingeniera Mecatrónica',
        university: 'Universidad Nacional de Ingeniería',
        sigUniv: 'UNI',
        description: 'Ingeniera Mecatrónica enfocada en IoT, sensores embebidos y sistemas inteligentes. Apasionada por desarrollar tecnologías para la industria aeroespacial, la aviónica y los sistemas autónomos. Especialista en sistemas IoT, Automatización y Edge Intelligence.',
        photo_url: '/images/04-capacitaciones/curso26agosto/docente.jpeg'
      }
    ],
    modules: [
      {
        title: 'Tu nuevo asistente de trabajo',
        topics: [
          'Aprender a conversar correctamente con la IA (prompts de nivel profesional)',
          'Conocer y comparar los 5 mejores asistentes del mercado (ChatGPT, Claude, Gemini, Kimi, Zai)',
          'Redacción, resolución de dudas técnicas y análisis de documentos',
          'Proyecto: Creación de tu asistente personal de trabajo configurado a tu rubro'
        ],
        duration: '2 horas'
      },
      {
        title: 'Presentaciones, imágenes e infografías',
        topics: [
          'Generación de presentaciones profesionales completas con IA',
          'Creación de diagramas de procesos, organigramas e infografías',
          'Generación de imágenes de calidad comercial (Gamma, Canva AI, Napkin AI, Ideogram)',
          'Proyecto: Presentación ejecutiva completa con infografías e imágenes generadas por IA'
        ],
        duration: '2 horas'
      },
      {
        title: 'Investigación en minutos',
        topics: [
          'Análisis e interrogación de documentos extensos y PDFs',
          'Investigación de empresas, estudios de mercado y comparación de competidores',
          'Uso de herramientas avanzadas de búsqueda y síntesis (Perplexity, NotebookLM, Deep Research, Genspark)',
          'Proyecto: Informe ejecutivo con fuentes, hallazgos y conclusiones'
        ],
        duration: '2 horas'
      },
      {
        title: 'Automatiza tu trabajo',
        topics: [
          'Integración de IA en correo, hojas de cálculo y reuniones',
          'Resumen automático de reuniones, transcripciones y seguimiento de tareas',
          'Generación de fórmulas y análisis en Excel con IA',
          'Proyecto: Flujo automatizado de reuniones + acta de tareas asignadas'
        ],
        duration: '2 horas'
      },
      {
        title: 'IA según tu profesión',
        topics: [
          'Construcción de kit personalizado según tu área de trabajo',
          'Desarrollo de biblioteca de prompts personalizados y plantillas reutilizables',
          'Documentación del flujo de trabajo semiautomatizado',
          'Proyecto final: Presentación y puesta en marcha de tu sistema personalizado'
        ],
        duration: '2 horas'
      }
    ],
    requirements: [
      'Estudiantes, profesionales y equipos que trabajan con documentos, reportes y presentaciones',
      'Deseo de aumentar la productividad sin necesidad de saber programar',
      'Conexión a internet y computadora para realizar los ejercicios en tiempo real'
    ],
    schedule: 'Lunes a viernes: 8:00 PM - 10:00 PM (1 semana pedagógica)',
    videoUrl: 'https://drive.google.com/file/d/1lVgb7LpULbrQo69lQiFjtos9mjcIrfw-/view?usp=sharing'
  },
  /*
{
    id: 'ia-herramientas-para-automatizacion',
    title: 'Herramientas de Inteligencia Artificial para tu Productividad ',
    description: 'Es un curso para aprender a redactar informes con IA, revisión de correos con IA, hojas de cálculo. La idea es hacer un flujo de trabajos semiautomatizado para ser más productivo.',
    duration: '24 horas',
    level: 'especializado',
    image: '/images/04-capacitaciones/curse_ia/llms.png',
    price: {
      costo:{
        uni: 300,
        gen: 350,
      },
      preventa:{
        uni: 200,
        gen: 250,
      }
    },
    category: 'IA',
    modality: 'online',
    startDate: '2026-03-10',
    docente:[
    {
      name: 'Aarón Flores Albeca',
      proffession: 'Ciencia de la Computación',
      university: 'Universidad Nacional de Ingeniería',
      sigUniv: 'UNI',
      description: 'Especialista en IA',
      photo_url: '/images/04-capacitaciones/curso26agosto/docente_mirna.jpeg'
    }
    ],
    modules: [
      {
        title: 'Fundamentos de IA generativa y estrategias de prompting ',
      topics: [
        'Fundamentos de IA generativa ',
        'Panorama de herramientas ',
        'Estrategias de prompting '
      ],
      duration: '6 horas'
      },
      {
        title: 'Análisis de información y datos asistido con IA ',
        topics: [
        'IA como asistente para datos',
        'Trabajo con hojas de cálculo',
        'Lectura y síntesis de información',
        'Del análisis al reporte '
        ],
        duration: '6 horas'
      },
      {
        title: 'Redacción asistida con IA generativa',
        topics: [
          'IA como coescritor',
          ' Casos de redacción habitual',
          'Control de estilo y calidad ',
          'Ética, originalidad y autoría '
        ],
        duration: '6 horas'
      },
      {
        title: 'Automatización de tareas y diseño de flujos de trabajo con IA ',
        topics: [
          'Identificación de tareas automatizables ',
          'Herramientas no-code y conectores ',
          'Diseño de flujos de trabajo con IA ',
          'Buenas prácticas y supervisión '
        ],
        duration: '6 horas'
      }
    ],
    requirements: [
    'Profesionales, estudiantes y personal administrativo que utilizan correo electrónico, documentos y hojas de cálculo, sin necesidad de conocimientos de programación.',
    'Compromiso y desempeño satisfactorio'
    ],
    schedule: 'Lunes, miércoles y viernes: 7:00 PM - 9:00 PM'
  },
*/
{
  id: 'computer-vision-deteccion-objetos',
  title: 'Computer Vision: Detección de Objetos con Deep Learning',
  description: 'Implementación práctica con YOLOv11, PyTorch y TensorFlow. Aprende a desarrollar sistemas de detección de objetos utilizando Deep Learning, desde redes neuronales convolucionales hasta tracking multi-objeto en tiempo real. Todo con recursos 100% gratuitos usando Google Colab.',
  duration: '24 horas',
  level: 'especializado',
  image: '/images/04-capacitaciones/curse_vc/curso_yolo11.webp',
  price: {
    costo: {
      uni: 300,
      gen: 400
    },
    preventa: {
      uni: 200,
      gen: 300
    }
  },
  category: 'IA',
  modality: 'online',
  startDate: '2026-08-17',
  docente: [
    {
      name: 'Guido Anthony Chipana Calderón',
      proffession: 'Ingeniero en Computer Vision',
      university: 'Universidad Nacional de Ingeniería',
      sigUniv: 'UNI',
      description: 'Ingeniero de Computer Vision en Tech Innovation, con experiencia desarrollando soluciones reales como detección de anomalías en prendas y medición automatizada con precisión. Investigador en TechLab-CTIC UNI, creando proyectos como Cuenta Personas con YOLOv11. Miembro activo de ACECOM IA y GETRA, con experiencia en modelos CNNs anti-suplantación y visión para robótica en el European Rover Challenge (Rover Prometeo).',
      photo_url: '/images/04-capacitaciones/curse_vc/instructor.png'
    }
  ],
  modules: [
    {
      title: 'Sesión 1: Fundamentos de Computer Vision',
      topics: [
        'Bienvenida y panorama de Computer Vision',
        'Fundamentos de imágenes digitales',
        'Configuración del entorno'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 2: Conceptos de Detección de Objetos',
      topics: [
        'Taxonomía de tareas en Computer Vision',
        'Métricas de evaluación (IoU, mAP)',
        'Introducción a YOLO'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 3: Redes Neuronales Básicas',
      topics: [
        'Introducción a Redes Neuronales',
        'PyTorch desde cero'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 4: Redes Neuronales Convolucionales',
      topics: [
        'Fundamentos de CNNs',
        'Implementación de CNN'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 5: Historia de la Detección de Objetos',
      topics: [
        'Evolución de algoritmos de detección',
        'Familia YOLO en detalle'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 6: Detección con YOLO',
      topics: [
        'YOLOv11 en profundidad',
        'Detección práctica'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 7: Preparación de Datasets',
      topics: [
        'Datasets y anotación',
        'Taller de creación de dataset'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 8: Data Augmentation y Transfer Learning',
      topics: [
        'Data Augmentation',
        'Transfer Learning y Fine-tuning'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 9: Entrenamiento de Modelos Custom',
      topics: [
        'Conceptos de entrenamiento',
        'Entrenamiento con YOLOv11'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 10: Evaluación y Optimización',
      topics: [
        'Evaluación de modelos',
        'Mejora y optimización'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 11: Object Tracking',
      topics: [
        'Fundamentos de Object Tracking',
        'Tracking con YOLOv11'
      ],
      duration: '2 horas'
    },
    {
      title: 'Sesión 12: Aplicaciones y Proyecto Final',
      topics: [
        'Aplicaciones en tiempo real',
        'Workshop de proyecto final'
      ],
      duration: '2 horas'
    }
  ],
  requirements: [
    'Estudiantes universitarios de Ingeniería o Ciencias',
    'Conocimientos básicos de Python (variables, funciones, listas)',
    'Álgebra lineal básica (vectores, matrices)',
    'NO se requiere experiencia previa en Machine Learning o Deep Learning',
    'NO se requiere GPU propia (se usa Google Colab con GPU gratuita)'
  ],
  schedule: 'Lunes, miércoles y viernes: 8:00 PM - 10:00 PM',
  videoUrl: 'https://drive.google.com/file/d/1xUD_3WUxUJTXh_UnUZDq9PWBTuHlOaCh/view?usp=sharing'
},
{
  id: 'controla-sistemas-inteligentes-con-esp32',
  title: 'Controla Sistemas Inteligentes con ESP32',
  description: 'Para hacer en un SOC lo que antes necesitabas un equipo completo de desarrollo, con firmware lo lograrás a nivel industrial. Configuración de periféricos en C sobre ESP-IDF, conectividad IoT (WiFi, HTTP, MQTT, JSON), protocolos industriales (RS485, Modbus RTU, Bluetooth Classic), FreeRTOS y conectividad 4G celular.',
  duration: '56 horas', // Módulo 1 (6 sesiones x 3.5h = 21h) + Módulo 2 (10 sesiones x 3.5h = 35h)
  level: 'especializado',
  image: '/images/04-capacitaciones/curse-esp32/curso_esp32.webp',
  price: {
    costo: {
      uni: 800, // Descuento por curso completo (Módulo 1 + Módulo 2)
      gen: 850
    },
    preventa: {
      uni: 400, // Precio por módulo individual
      gen: 450
    }
  },
  category: 'IoT',
  modality: 'online',
  startDate: '2026-08-17',
  docente: [
    {
      name: 'Carlos Alberto Lazo Quispe',
      proffession: 'Ingeniero Electrónico',
      university: 'Universidad Nacional de Ingeniería',
      sigUniv: 'UNI',
      description: 'Ingeniero electrónico especialista en ESP32, ESP-IDF, FreeRTOS y comunicación IoT/4G para aplicaciones reales en el sector minero, incluyendo conectividad 4G y monitoreo remoto en campo.',
      photo_url: '/images/04-capacitaciones/curse-esp32/carlos_cursoesp32.webp'
    }
  ],
  modules: [
    {
      title: 'Módulo 1: Arquitectura del ESP32, periféricos y conectividad IoT industrial',
      topics: [
        'Arquitectura del ESP32 y entorno ESP-IDF: componentes y C aplicado a embebidos',
        'Periféricos de entrada/salida: GPIO, ADC, DAC, PWM, temporizadores e interrupciones',
        'Comunicación y almacenamiento: UART, I2C, SPI (LCD 4x20, RTC) y SDCard',
        'Conectividad WiFi: Modo estación, punto de acceso y Servidor Web en ESP32',
        'Protocolos IoT y datos: HTTP, MQTT y JSON para la nube',
        'Comunicación inalámbrica y de campo: Bluetooth Classic, RS485 y Modbus RTU industrial'
      ],
      duration: '21 horas' // 6 sesiones de 3h 30min
    },
    {
      title: 'Módulo 2: FreeRTOS, firmware profesional y aplicaciones con 4G',
      topics: [
        'Programación multitarea con FreeRTOS: Tareas, scheduler, prioridades y gestión de recursos',
        'Sincronización y comunicación: Colas, semáforos, mutex y grupos de eventos',
        'Confiabilidad de firmware: Arquitectura por capas y componentes personalizados en ESP-IDF',
        'Conectividad 4G en campo: Comandos AT y control de módem celular sin dependencia de WiFi',
        'Integración y monitoreo remoto: Envío y recepción de datos HTTP/MQTT vía 4G'
      ],
      duration: '35 horas' // 10 sesiones de 3h 30min
    }
  ],
  requirements: [
    'Estudiantes de ingeniería electrónica, mecatrónica, electricista o desarrolladores de firmware',
    'Interés en crear proyectos IoT o sistemas con comunicación inalámbrica a celular/nube',
    'Conocimientos básicos de programación en C/C++ y electrónica general'
  ],
  schedule: 'Martes y jueves: 7:00 PM - 10:30 PM',
  videoUrl: 'https://drive.google.com/file/d/1SJvhPJFjZ7uYnf8qas_IEAtFG3l0ZRDo/view?usp=sharing'
}
  
];
